import React, { useEffect, useMemo, useState } from 'react';
import Table from '../../../components/Tables/ExpandedTable';
import { headerMaker } from '../../../components/Tables/ExpandedTable/helper';
import { productsHeader } from '../../../redux/modules/table/common';
import { useSelector, useDispatch } from 'react-redux';
import reports from '../../../services/reports';
import rateType from '../../../services/ratingtype';
import Spinner from '../../../components/Spinner';
import { setReportSubData } from '../../../redux/modules/application/actions';
import { makeReport } from '../../../utils/makeReport';
import { groupHeaders } from '../../../utils/groupHeader';
import RangePicker from '../../../components/RangePicker';
import Select from '../../../components/FormElements/Select';
import { Col, Row } from 'antd';
import { setSelectedDate } from '../../../redux/modules/dates/actions';
import moment from 'moment';
import { usePaginate } from 'hooks/usePaginate';

export default () => {
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );

  const [reportsData, setReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const dispatch = useDispatch();
  const { data, handleOnTableChange, pageCount } = usePaginate();

  const [group, setGroup] = useState('');
  const [newHeader, setNewHeader] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    const foo = headerMaker(productsHeader.concat(groupHeaders(newHeader)));
    setHeaders(foo);
  }, [newHeader]);

  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );

  const fetchRateReports = async () => {
    try {
      setLoading(true);
      const data = {
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        group,
      };
      const ratesType = await rateType.getAll();

      const reportData = await reports.getAllRateReport(data);
      const myCat = reportData[0]?.categorys.map((i) => i.category);
      setNewHeader(categories.filter((i) => myCat.includes(i._id)));
      const report = makeReport(
        reportData,
        regions,
        groups,
        categories,
        users,
        ratesType
      );
      setReportsData(
        report
          .sort((a, b) => b.total.value - a.total.value)
          .map((item, index) => ({ ...item, id: index + 1 }))
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    setGroup(groups[0]?._id);
  }, [groups]);

  useEffect(() => {
    if (!selectedDate.every((item) => item === '') && group !== '') {
      fetchRateReports();
    }
  }, [dateQuery, categories, groups, regions, group]);

  const handleSelectgroup = async (id, userId) => {
    try {
      setLoadingSub(true);
      const data = {
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        user: userId,
        category: id,
      };
      const resp = await reports.getAllRateReport(data);

      const subCats = categories.filter((item) => item.parent === id);
      const report = subCats.map((item, idx) => {
        const subCat = resp.find((itm) => itm.subCategory === item._id);
        return {
          id: idx + 1,
          name: item?.title,
          total: subCat?.rate
            ? Math.min(Math.round(subCat?.rate), 100)
            : subCat?.rate,
          count: subCat.workCount,

          // regionId: regionId,
        };
      });

      dispatch(setReportSubData(report ? report : []));
      setLoadingSub(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    return () => {
      if (selectedDate[0] === '' && selectedDate[1] === '') {
        const today = moment();
        const yesterday = moment(today).subtract(1, 'days');
        dispatch(
          setSelectedDate([
            today.format('YYYY-MM-DD'),
            yesterday.format('YYYY-MM-DD'),
          ])
        );
      }
    };
  }, []);

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <>
      <Row align='middle' justify='end' gutter={20}>
        <Col>
          <Select
            allowClear={false}
            options={groups}
            defaultVal={group}
            handleChange={(value) => setGroup(value)}
          />
        </Col>
        <Col>
          <div style={{ padding: ' 20px 0' }}>
            <RangePicker />
          </div>
        </Col>
      </Row>

      <Table
        headers={headers}
        selectgroup={handleSelectgroup}
        loading={loadingSub}
        onChange={handleOnTableChange}
        total={reportsData.length}
        data={data}
        reportsData={reportsData}
        page={pageCount}
      />
    </>
  );
};
